import { Box, Loader, Spacer, Text } from '@jfs/ui-new'
import { useEffect } from 'react'
import { SvgImage } from '../../comps/SvgImage'
import { DeviceShare } from '../../util/permissions'
import { Colors } from '../../util/util'

export const share = async (path: any) => {
  try {
    const shareData = {
      url: `file://'${path}`,
      text: `${path}`,
    }
    await DeviceShare(shareData)
  } catch (err) {
    console.log('share error', err)
  }
}

export const ShareImage = ({ handleShare, sharehandler }: any) => {
  useEffect(() => {
    if (sharehandler.state === 'fulfilled' && sharehandler?.data?.status === 200) {
      share(sharehandler?.data?.path)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sharehandler.state])
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      underlayColor="PRIMARY_LIGHT_GREY"
      testID="share-qr"
      onPress={handleShare}>
      {sharehandler.state === 'pending' ? (
        <Loader color={Colors.PRIMARY} type="small" />
      ) : (
        <SvgImage color={Colors.PRIMARY} imageName={'Share'} />
      )}
      <Spacer size="TINY" direction="horizontal" />
      <Text fontFamily={'JioType-Medium'} fontSize={14} color="PRIMARY">
        Share
      </Text>
    </Box>
  )
}
